import { mediaService } from 'dibs-service-fetch-wrappers';

type ValidateDimensionsPayload = {
    files?: Array<File | Blob>;
    minWidth: number;
    minHeight: number;
};

export type UploadImagePayload = {
    userId: string;
    files: File[];
    photoType: 'PUBLIC_PROFILE_COVER' | 'PUBLIC_PROFILE_AVATAR';
};

type UploadImageResponse = {
    photo: {
        id: number | string;
        dimension: { width: number; height: number };
        path: string;
    };
};

export type MediaInfo = {
    dimension?: { height: number; width: number };
    mediaLocation: string | null;
    mediaId: number | string;
    parentId?: number | string;
};

export const isImageValidDims = async (
    payload: ValidateDimensionsPayload
): Promise<{ dimensionsValid: boolean; error?: string }> => {
    const updatedPayload = {
        ...payload,
        file: payload.files?.[0],
    };

    return new Promise(resolve => {
        mediaService
            .ensureValidPhotoDimensions({
                payload: updatedPayload,
                onSuccess: () => resolve({ dimensionsValid: true }),
                onFail: (error: { message: string }) =>
                    resolve({ dimensionsValid: false, error: error.message }),
            })
            .catch((e: unknown) => {
                // eslint-disable-next-line no-console
                console.error('image validation error', e);
            });
    });
};

export const uploadImage = async ({
    userId,
    files,
    photoType,
}: UploadImagePayload): Promise<{ mediaInfo: MediaInfo | null }> => {
    const defaultData = {
        apiType: 'photo',
        name: null,
        metadata: null,
        owner: {
            apiType: 'anchor',
            sourceId: userId,
            sourceType: 'USER',
        },
    };

    const updatedData = Object.assign({}, defaultData);
    const updatedPayload = Object.assign(
        {},
        {
            data: updatedData,
            file: files?.[0],
            pathSegment: '/nft',
            photoType,
        }
    );

    return new Promise(resolve => {
        mediaService
            .uploadPhoto({
                payload: updatedPayload,
                onSuccess: ({ photo }: UploadImageResponse) => {
                    const mediaInfo = {
                        dimension: {
                            width: photo.dimension.width,
                            height: photo.dimension.height,
                        },
                        mediaLocation: photo.path,
                        mediaId: photo.id,
                    };
                    resolve({ mediaInfo });
                },
                onFail: () => resolve({ mediaInfo: null }),
            })
            .catch(() => {
                resolve({ mediaInfo: null });
            });
    });
};
